import { render, staticRenderFns } from "./AdTab.ts.vue?vue&type=template&id=a22a16a6"
import script from "./AdTab.ts.vue?vue&type=script&lang=ts"
export * from "./AdTab.ts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports